import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Pill } from "@/admin/AdminLayout";

const fmt = (s: string) => (s ? new Date(s).toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" }) : "—");

function Card({ label, total, live, hidden, active, onClick, testId }: any) {
  return (
    <button onClick={onClick} className={`text-left bg-white border p-5 transition-colors ${active ? "border-neutral-900" : "border-neutral-200 hover:border-neutral-500"}`} data-testid={testId}>
      <p className="eyebrow text-[10px] text-neutral-500">{label}</p>
      <p className="font-display text-4xl mt-2">{total}</p>
      <p className="text-xs text-neutral-500 mt-1">{live} live · {hidden} hidden</p>
    </button>
  );
}

export function ContentTally() {
  const [d, setD] = useState<any>(null);
  const [sel, setSel] = useState("all");
  useEffect(() => { api.get("/admin-x/content-tally").then((r) => setD(r.data)).catch(() => setD(false)); }, []);
  if (!d) return null;
  const rows = (sel === "all" ? d.sections.flatMap((s: any) => s.items.map((i: any) => ({ ...i, section: s.label }))) : d.sections.find((s: any) => s.key === sel).items.map((i: any) => ({ ...i, section: d.sections.find((s: any) => s.key === sel).label })))
    .sort((a: any, b: any) => (b.updated || "").localeCompare(a.updated || ""));
  return (
    <div className="mt-10" data-testid="content-tally">
      <p className="eyebrow text-[10px] text-neutral-500 mb-3">Site pages tally · matches the public sitemap automatically</p>
      <div className="grid sm:grid-cols-3 xl:grid-cols-5 gap-3">
        <Card label="All pages" total={d.total} live={d.live} hidden={d.hidden} active={sel === "all"} onClick={() => setSel("all")} testId="tally-all" />
        {d.sections.map((s: any) => <Card key={s.key} {...s} active={sel === s.key} onClick={() => setSel(s.key)} testId={`tally-${s.key}`} />)}
      </div>
      <div className="bg-white border border-neutral-200 mt-4 max-h-[480px] overflow-auto" data-testid="tally-list">
        <table className="w-full text-sm">
          <thead className="sticky top-0 bg-white"><tr className="text-left eyebrow text-[10px] text-neutral-500 border-b border-neutral-200">
            <th className="p-3">Page</th><th className="p-3">Section</th><th className="p-3">Status</th><th className="p-3">First appeared</th><th className="p-3">Last updated</th></tr></thead>
          <tbody>
            {rows.map((r: any) => (
              <tr key={r.url} className="border-b border-neutral-100" data-testid={`tally-row-${r.url.replace(/[^a-z0-9]+/gi, "-")}`}>
                <td className="p-3"><a href={r.url} target="_blank" rel="noreferrer" className="hover:underline">{r.title}</a><span className="block text-xs text-neutral-400">{r.url}</span></td>
                <td className="p-3 text-neutral-600">{r.section}</td>
                <td className="p-3"><Pill tone={r.live ? "green" : "amber"}>{r.live ? "live" : "hidden"}</Pill></td>
                <td className="p-3 whitespace-nowrap">{fmt(r.first_seen)}</td>
                <td className="p-3 whitespace-nowrap">{fmt(r.updated)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
